import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';

import Icon from '~/components/Icon';
import { useIsMobileDevice } from '~/hooks';
import { I18n } from '~/i18n';
import { theme } from '~/theme';
import { TextButton } from '../common/Buttons';

interface Props {
  handleModalClose: () => void;
  showModal: boolean;
}

const ZoneInformationModal: React.FC<Props> = ({
  handleModalClose,
  showModal = false,
}) => {
  const isMobile = useIsMobileDevice();
  return (
    <Modal open={!!showModal} onClose={handleModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 500,
          minWidth: isMobile ? '80vw' : undefined,
          padding: theme.spacing(3, 2),
          bgcolor: theme.palette.common.white,
          borderRadius: theme.spacing(1),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: theme.spacing(0.5),
          }}
        >
          <Icon
            name={'Information'}
            size={16}
            color={theme.palette.secondary.main}
          />
          <Typography
            id="modal-modal-title"
            variant="h3"
            sx={{ textTransform: 'none' }}
          >
            {I18n.t('zoneDetails.aboutZones')}
          </Typography>
          <IconButton
            onClick={handleModalClose}
            aria-label={I18n.t('common.close')}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <Icon name="Close" size={16} color={theme.palette.secondary.main} />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
            flexDirection: 'column',
            mt: 2,
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="body2"
            sx={{ textTransform: 'none' }}
            lineHeight={1.5}
          >
            <Trans
              i18nKey={'zoneDetails.zoneDisclaimer'}
              components={{ strong: <strong /> }}
            />
          </Typography>
          <Typography
            id="modal-modal-title"
            variant="body2"
            sx={{ textTransform: 'none', mt: 3 }}
          >
            <i>{I18n.t('zoneDetails.zoneDisclaimerTip')}</i>
          </Typography>
          <Button
            onClick={handleModalClose}
            variant="outlined"
            sx={{ borderRadius: 1, ml: 'auto', mt: 1 }}
            color="secondary"
          >
            {I18n.t('common.back')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ZoneInformationModal;
